import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { FULL_TESTIMONIALS } from '../../data/content';
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-213" data-mp="3mh2cbymv9mhp">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-lime text-lime" aria-hidden="true" data-id="element-214" data-mp="3r7sg57fn9haa" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="relative w-full bg-ink px-5 py-12 sm:py-16" data-id="element-215" data-mp="3ahgee7sel5">
      <div className="mx-auto max-w-5xl text-center" data-id="element-216" data-mp="41i23kbsu01m">
        <SectionBadge color="magenta" data-id="element-217" data-mp="925plw0tjyr3">❤️ Más docentes que ya lo tienen</SectionBadge>
        <h2 className="mt-4 font-display text-3xl text-white sm:text-5xl" data-id="element-218" data-mp="e0z33og3vpr9">
          Profes que recuperaron su tiempo
        </h2>

        <div className="mt-7 grid gap-3 text-left sm:grid-cols-2" data-id="element-219" data-mp="2au2avxcsgmz2">
          {FULL_TESTIMONIALS.map(t => <div key={t.name} className="flex flex-col rounded-xl border border-ink-border bg-ink-card p-4" data-id="element-220" data-mp="2ftevebg6thyh">
              <div className="flex items-center gap-3" data-id="element-221" data-mp="1slazblveovap">
                <img src={t.avatar} alt={`Foto de ${t.name}, instructora de Zumba`} width={96} height={96} loading="lazy" decoding="async" className="h-12 w-12 rounded-full object-cover ring-2 ring-magenta/50" data-id="element-222" data-mp="1nu2nykaimzuw" />
                <div data-id="element-223" data-mp="2bily75d4lmpm">
                  <p className="font-bold leading-tight text-white" data-id="element-224" data-mp="2bh11pa793tp4">{t.name}</p>
                  <p className="text-xs text-white/50" data-id="element-225" data-mp="26l3kl1o5yjba">{t.city}</p>
                  <div className="mt-0.5" data-id="element-226" data-mp="22hns8hj4n54e"><Stars data-id="element-227" data-mp="22h5n0vehlgkc" /></div>
                </div>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-white/80" data-id="element-228" data-mp="1xiklmsni0qub">“{t.quote}”</p>
            </div>)}
        </div>
      </div>
    </section>;
}